import React, { forwardRef } from "react";
import "./ReportTableScroll.css";

export default forwardRef(function ReportTableScroll({ label, children }, ref) {
  return (
    <div ref={ref} className="fb-report-table-scroll" role="region" aria-label={label} tabIndex={0}>
      {children}
    </div>
  );
});
